import { CATS } from '../data/catalog.js';
import { fmt } from '../lib/money.js';
import { useStore } from '../lib/store.jsx';
import { useI18n } from '../lib/i18n.jsx';
import ProductCard from '../components/ProductCard.jsx';
import ProductViz from '../components/ProductViz.jsx';

const FEATURED = ['nobox', 'cowboy-grill', 'nakiri-n7', 'edison-stick', 'folding-picnic', 'grill-mat', 'pivot-lighter', 'multi-pocket'];

export default function Home({ nav }) {
  const { products, P } = useStore();
  const { t } = useI18n();
  // hero = ตะเกียง Railroad Slate Gray (มีสต็อก · ถ้าไม่เจอค่อย fallback ตัวแรก)
  const hp = P('railroad-lantern-slate-gray') || P('LIV-282') || products[0];
  const feat = FEATURED.map((id) => P(id)).filter(Boolean);
  const featList = feat.length ? feat : products.slice(0, 8);

  return (
    <>
      <section className="hero">
        <div className="wrap">
          <div>
            <div className="eyebrow">Barebones Living · CAMP STUDIO</div>
            <h1>Beautiful.<br />Durable.<br /><span className="li">Essential.</span></h1>
            <p className="lede">{t('home.lede')}</p>
            <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              <button className="btn" onClick={() => nav('/c/all')}>{t('home.shopAll')}</button>
              <button className="btn ghost" onClick={() => nav('/c/cook-dine')}>Cook &amp; Dine</button>
            </div>
            <div className="thesis">
              <div><h4>Beautiful</h4><span>{t('home.thesis.beautiful')}</span></div>
              <div><h4>Durable</h4><span>{t('home.thesis.durable')}</span></div>
              <div><h4>Essential</h4><span>{t('home.thesis.essential')}</span></div>
            </div>
          </div>
          {hp && (
            <div className="herocard" onClick={() => nav(`/p/${hp.id || hp.sku}`)}>
              <div className="imgw"><ProductViz product={hp} size="big" priority /></div>
              <div className="meta">
                <div className="nm">{hp.name}</div>
                <div className="pr">{hp.price !== null ? fmt(hp.price) : t('pdp.ask')}</div>
              </div>
            </div>
          )}
        </div>
      </section>

      <div className="catstrip">
        {Object.entries(CATS).map(([k, c]) => (
          <a key={k} className="catcell" href={`/c/${k}`} onClick={(e) => { e.preventDefault(); nav(`/c/${k}`); }}>
            <div className="bg" style={{ background: `linear-gradient(150deg,${c.g1},${c.g2})` }} />
            <span className="n">{c.n} / Collection</span>
            <span className="t">{c.t}</span>
            <span className="d">{t(`cat.${k}.d`)}</span>
            <span className="arw">{t('home.browse')}</span>
          </a>
        ))}
      </div>

      <section className="blk">
        <div className="wrap">
          <div className="shead">
            <div><div className="sub">{t('home.featured')}</div><h2>Everyday Essentials</h2></div>
            <button className="btn ghost sm" onClick={() => nav('/c/all')}>{t('home.viewAll')}</button>
          </div>
          <div className="grid">
            {featList.map((p) => <ProductCard key={p.id} product={p} nav={nav} />)}
          </div>
        </div>
      </section>

      <section className="blk authentic">
        <div className="wrap">
          <div className="auth-card">
            <span className="auth-badge">ORIGINAL DESIGN</span>
            <h2>BAREBONES THAILAND</h2>
            <p>{t('home.authentic')}</p>
          </div>
        </div>
      </section>

      <section className="blk" style={{ background: 'var(--warm)', borderTop: '1px solid var(--line)' }}>
        <div className="wrap">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(240px,1fr))', gap: 1, background: 'var(--line)', border: '1px solid var(--line)' }}>
            {[
              [t('home.f1.t'), t('home.f1.d')],
              [t('home.f2.t'), t('home.f2.d')],
              [t('home.f3.t'), t('home.f3.d')],
            ].map(([tt, d]) => (
              <div key={tt} style={{ background: '#fff', padding: '26px 24px' }}>
                <div className="eyebrow">●</div>
                <h3 style={{ fontSize: 22, textTransform: 'uppercase', margin: '8px 0 6px' }}>{tt}</h3>
                <p style={{ fontSize: 13.5, color: 'var(--ink-2)', margin: 0 }}>{d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
